<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Evaluation_Record')"/><!-- 评估记录 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:''
        }
    },
    computed:{
        columns(){
            let arr = [
                {
                    title: this.$t('Year'),/* 年度 */
                    key: "year",
                    align: "center",
                    minWidth: 100,
                    ellipsis:true,
                },{
                    title: this.$t('Performance_WHAT'),/* 绩效(WHAT) */
                    key: this.lang=='zh'?"what_score":"enWhatScore",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },{
                    title: this.$t('Performance_HOW'),/* 绩效(HOW) */
                    key: this.lang=='zh'?"how_score":"enHowScore",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Perdormance_OVERALL'),/* 绩效(OVERALL) */
                    key: this.lang=='zh'?"whole_score":"enWholeScore",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Potential'),/* 潜能 */
                    key: this.lang=='zh'?"potential_score":"enPotentialScore",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
            ]
            if(!this.id) {
                arr.pop()
            }
            return  arr
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    created() {
        this.id = this.getQueryVariable('id')
    },
    methods:{
        getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/evaluationRecord/getEvaluationRecord", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
        },
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                return pair[1];
                }
            }
            return false;
        }
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/EvaluationRecord.vue